import React__default, { useState, useEffect } from 'react';
import Styles from './RatingStars.module.scss.js';
import { ReactComponent as SvgStarGolden } from '../../icons/StarGolden.svg.js';
import { ReactComponent as SvgStarHalfGolden } from '../../icons/StarHalfGolden.svg.js';
import { ReactComponent as SvgStarEmpty } from '../../icons/starEmpty.svg.js';
import classNames from 'classnames';

function getStarsCount(rating) {
    const stars = { full: 0, half: 0, empty: 0 };
    const halfRounded = Math.round(rating * 2) / 2;
    if (Math.ceil(rating) - halfRounded === 0.5) {
        stars.half = 1;
        stars.full = Math.floor(halfRounded);
        stars.empty = 5 - Math.ceil(halfRounded);
    }
    else {
        stars.half = 0;
        stars.full = halfRounded;
        stars.empty = 5 - halfRounded;
    }
    return stars;
}
const RatingStars = ({ rating, className }) => {
    const [stars, setStars] = useState({});
    useEffect(() => {
        setStars(getStarsCount(rating));
    }, [rating]);
    return (React__default.createElement("span", { className: classNames(Styles.main, className) },
        (stars === null || stars === void 0 ? void 0 : stars.full)
            ? [...Array(stars.full)].map((n, i) => React__default.createElement(SvgStarGolden, { className: Styles.star, key: i }))
            : "",
        (stars === null || stars === void 0 ? void 0 : stars.half)
            ? stars.half === 1 && React__default.createElement(SvgStarHalfGolden, { className: classNames(Styles.star, Styles.halfStar) })
            : "",
        (stars === null || stars === void 0 ? void 0 : stars.empty)
            ? [...Array(stars.empty)].map((n, i) => React__default.createElement(SvgStarEmpty, { className: Styles.star, key: i }))
            : ""));
};

export { RatingStars as default };
//# sourceMappingURL=RatingStars.js.map
